import { render, staticRenderFns } from "./homeMiniProgramBar.vue?vue&type=template&id=e884308a&scoped=true&"
import script from "./homeMiniProgramBar.vue?vue&type=script&lang=js&"
export * from "./homeMiniProgramBar.vue?vue&type=script&lang=js&"
import style0 from "@ajk/touch-vue-components/src/components/biz-app-download-bar/biz-app-download-bar.css?vue&type=style&index=0&id=e884308a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e884308a",
  null
  
)

export default component.exports